export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: '📥',
      title: 'Upload eller modtag dokumenter',
      desc: 'PDF og Excel kommer ind i systemet automatisk – via API, e-mail eller direkte upload.',
    },
    {
      number: '02',
      icon: '🔄',
      title: 'Konvertering til data',
      desc: 'Dokumenter omdannes automatisk til struktureret JSON-data klar til videre behandling.',
    },
    {
      number: '03',
      icon: '✅',
      title: 'Validering i jeres system',
      desc: 'Data matches og valideres direkte i ERP eller andre systemer uden manuel indgriben.',
    },
    {
      number: '04',
      icon: '🖥️',
      title: 'Overblik i portal',
      desc: 'Se status, fejl og historik ét sted. Fuld transparens over hele jeres dokumentflow.',
    },
  ];

  return (
    <section className="py-24 px-6 md:px-12 border-b border-border relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 reveal">
          <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground block mb-4">
            03 / SÅDAN VIRKER DET
          </span>
          <h2 className="text-4xl md:text-6xl text-foreground tracking-tight font-serif font-light mb-4">
            Fra dokument til data – automatisk
          </h2>
          <p className="text-muted-foreground max-w-2xl">
            Spar tid, reducer fejl og få fuldt overblik over dine dokumentflows på tværs af systemer.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps?.map((step, i) => (
            <div
              key={i}
              className={`p-8 border border-border rounded-xl bg-card hover:border-primary/30 transition-colors group reveal delay-${(i + 1) * 100}`}
            >
              <div className="flex items-center justify-between mb-6">
                <span className="text-4xl">{step?.icon}</span>
                <span className="text-xs font-mono text-muted-foreground/50">{step?.number}</span>
              </div>
              <h3 className="text-lg text-foreground font-medium mb-3">{step?.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step?.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
